import { render } from "./edithuiyuan.vue?vue&type=template&id=068962ba&scoped=true"
import script from "./edithuiyuan.vue?vue&type=script&lang=js"
export * from "./edithuiyuan.vue?vue&type=script&lang=js"

import "./edithuiyuan.vue?vue&type=style&index=0&id=068962ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068962ba"]])

export default __exports__